import * as TabsPrimitive from '@radix-ui/react-tabs';
import type * as React from 'react';

import { cn } from '~/utils/cn.ts';

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
	return <TabsPrimitive.Root className={cn('flex flex-col gap-2', className)} data-slot="tabs" {...props} />;
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
	return (
		<TabsPrimitive.List
			className={cn(
				// Lyra style: sharp corners, h-8, text-xs
				'inline-flex h-8 items-center justify-center gap-1 rounded-none bg-muted p-1 text-muted-foreground',
				className,
			)}
			data-slot="tabs-list"
			{...props}
		/>
	);
}

function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
	return (
		<TabsPrimitive.Trigger
			className={cn(
				// Lyra style: sharp corners, text-xs
				'inline-flex items-center justify-center whitespace-nowrap rounded-none px-3 py-1',
				'font-medium text-xs transition-all',
				// Focus styles
				'focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring',
				// Disabled styles
				'disabled:pointer-events-none disabled:opacity-50',
				// Active state
				'data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm',
				className,
			)}
			data-slot="tabs-trigger"
			{...props}
		/>
	);
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
	return (
		<TabsPrimitive.Content
			className={cn('mt-2 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring', className)}
			data-slot="tabs-content"
			{...props}
		/>
	);
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
